module.exports = __webpack_public_path__ + "img/01.834513a8.jpg";